import {
  GetIssuesAICreationSettingsRequest,
  GetIssuesAICreationSettingsResponse,
  UpdateIssuesAICreationSettingsRequest,
  UpdateIssuesAICreationSettingsResponse,
} from "@safetyculture/s12-apis-connect-web/s12/tools/support/v1/support_pb";

import { supportServiceConnectClient } from "../index";
import { RequestMetadata } from "api/types";
import { toUUID } from "helpers/s12-helpers";

export type GetIssuesAICreationSettingsParams = {
  orgId: string;
};

export const getIssuesAICreationSettings = async (
  { orgId }: GetIssuesAICreationSettingsParams,
  headers: Record<RequestMetadata, string>,
): Promise<GetIssuesAICreationSettingsResponse> => {
  const req = new GetIssuesAICreationSettingsRequest({
    orgId: toUUID(orgId),
  });

  return supportServiceConnectClient.getIssuesAICreationSettings(req, {
    headers,
  });
};

export type UpdateIssuesAICreationSettingsParams = {
  orgId: string;
  enabled: boolean;
};

export const updateIssuesAICreationSettings = async (
  { orgId, enabled }: UpdateIssuesAICreationSettingsParams,
  headers: Record<RequestMetadata, string>,
): Promise<UpdateIssuesAICreationSettingsResponse> => {
  const req = new UpdateIssuesAICreationSettingsRequest({
    orgId: toUUID(orgId),
    enabled,
  });

  return supportServiceConnectClient.updateIssuesAICreationSettings(req, {
    headers,
  });
};
